import { RiseOutlined, RocketOutlined, StarOutlined } from "@ant-design/icons";

export const PREDEFINED_REPORTS: any = {
     
    GLOBAL_REVIEWS: { name: "Resumen de reseñas", scope:"PROJECT", icon: StarOutlined, scopeName:"Proyecto" },
    GLOBAL_SEO: { name: "Resumen de SEO", scope:"PROJECT", icon: RocketOutlined, scopeName:"Proyecto" },
    GLOBAL_PERFORMANCE: { name: "Resumen de rendimiento", scope:"PROJECT", icon: RiseOutlined, scopeName:"Proyecto" },
//    GLOBAL_SENTIMENT: { name: "Resumen de sentimiento", scope:"PROJECT", icon: RocketOutlined, scopeName:"Proyecto" },
//    GLOBAL_QR: { name: "Resumen de QR", scope:"PROJECT", icon: RocketOutlined, scopeName:"Proyecto" },
    LIST_OF_REVIEWS: { name: "Lista de reseñas", scope:"LOCATION", icon: StarOutlined, scopeName:"Local" },
    LIST_OF_REVIEWS_BY_LOCATION_MAK: { name: "Lista de reseñas *", scope:"LOCATION", icon: StarOutlined, scopeName:"Local" },
};
